import React, { Component } from "react";
import Banner from "../../components/common/Banner";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import AdmissionSidebar from "./components/AdmissionSidebar";

export default class MCA extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Admission" image="banners/banner-admission.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Seats available</h4>
                    </div>
                    <div className="ttm-service-description">
                      <table class="table">
                        <thead
                          style={{ backgroundColor: "#98002e", color: "white" }}
                        >
                          <tr>
                            <th style={{ width: "10%" }}>Sl No</th>
                            <th style={{ width: "40%" }}>Branches</th>
                            <th style={{ width: "10%" }}>Total Intake</th>
                            <th style={{ width: "10%" }}>PGCET</th>
                            <th style={{ width: "10%" }}>Management</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th>1</th>
                            <td>MCA</td>
                            <td>180</td>
                            <td>90</td>
                            <td>90</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="ttm-service-description paddingtop-2">
                    <div className="section-title with-desc text-left clearfix">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h4 className="title">
                          Admission process and eligibility
                        </h4>
                      </div>
                    </div>
                    <p>
                      Entrance Examination: KMAT / PGCET – Any One is Mandatory
                    </p>
                    <br />
                    <p className="justify">
                      Candidates seeking admission should have cleared
                      qualifying examination which being any recognized
                      Bachelor’s Degree with Mathematics or Statistics or
                      Computer Science or Computer Application or Computer
                      Programming or Business Mathematics or Business Statistics
                      as one of the optional subjects and minimum of 3 years
                      duration or equivalent examination. Student should have
                      obtained 5.75 CGPA (for General Merit Candidates) is
                      eligible for admission to full time MCA course and 5.25
                      CGPA in qualifying examination in case of SC, ST and
                      Category-I Candidates.
                    </p>
                  </div>
                </div>

                <div className="section-title with-desc text-left clearfix">
                  <div
                    className="title-header paddingtop-2"
                    style={{ borderTopColor: "red" }}
                  >
                    <h4 className="title">
                      Following Documents are requested to be submitted during
                      admission{" "}
                    </h4>
                  </div>
                  <div className="ttm-pf-single-detail-box mb-35">
                    <ul className="ttm-pf-detailbox-list">
                      <li>
                        <i className="fa fa-caret-right" />
                        <span>PGCET Allotment Order four photocopies</span>
                      </li>
                      <li>
                        <i className="fas fa-caret-right" />
                        <span>
                          10th, 12th &#38; All Degree Original Marks Cards and
                          three Photocopies{" "}
                        </span>
                      </li>
                      <li>
                        <i className="fas fa-caret-right" />
                        <span>PDC Certificate and three Photocopies</span>
                      </li>
                      <li>
                        <i className="fas fa-caret-right" />
                        <span>Transfer Certificate and three Photocopies</span>
                      </li>
                      <li>
                        <i className="fas fa-caret-right" />
                        <span>Aadhar Card three photocopies </span>
                      </li>
                      <li>
                        <i className="fas fa-caret-right" />
                        <span>Three Passport Size Photos </span>
                      </li>
                      <li>
                        <i className="fas fa-caret-right" />
                        <span>
                          Income &#38; Caste Certificate three Photocopies{" "}
                        </span>
                      </li>
                      <li>
                        <i className="fas fa-caret-right" />
                        <span>DD in Favor of PRINCIPAL BIT </span>
                      </li>
                    </ul>
                  </div>

                  <div className="section-title with-desc text-left clearfix paddingtop-2">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">
                        Online Fee Payment Conditions and Refund Policies
                      </h4>
                    </div>

                    <div>
                      <h6 className="text-secondary font-weight-bold">
                        Online Fee Payment Conditions
                      </h6>
                      <br />
                      <p className="text-muted">
                        <strong>As per the guidelines of AICTE and VTU.</strong>
                      </p>
                      <br />
                      <div className="mb-3">
                        <h6 className="font-weight-bold">Payment Method</h6>
                        <ul
                          className="list-group"
                          style={{ marginTop: "12px" }}
                        >
                          <li className="list-group-item">
                            Payments can usually be made through debit/credit
                            cards, bank transfers, UPI, or integrated
                            third-party payment gateways.
                          </li>
                          <li className="list-group-item">
                            Ensure that the payment method is accepted by the
                            platform or service provider.
                          </li>
                        </ul>
                      </div>

                      <div className="mb-3">
                        <h6 className="font-weight-bold">Timing of Payment</h6>
                        <ul className="list-group">
                          <li
                            className="list-group-item"
                            style={{ marginTop: "12px" }}
                          >
                            Payments may be due by a specific date. Late
                            payments might incur penalties or interest charges.
                          </li>
                          <li className="list-group-item">
                            Some platforms may allow for automatic payment
                            processing, and others may require manual action.
                          </li>
                        </ul>
                      </div>

                      <div className="mb-3">
                        <h6 className="font-weight-bold">
                          Confirmation of Payment
                        </h6>
                        <ul className="list-group">
                          <li
                            className="list-group-item"
                            style={{ marginTop: "12px" }}
                          >
                            Mobile number entered on the payment should be
                            correct, and the same will be used for verifying
                            payment status.
                          </li>
                          <li className="list-group-item">
                            After a successful transaction, a confirmation
                            receipt or transaction ID is often sent to the
                            user's registered email or phone number.
                          </li>
                          <li className="list-group-item">
                            It's essential to keep this confirmation as proof of
                            payment.
                          </li>
                          <li className="list-group-item">
                            The receipt can be downloaded or collect from the
                            college office.
                          </li>
                        </ul>
                      </div>

                      <div className="mb-3">
                        <h6
                          className="font-weight-bold"
                          style={{ marginTop: "12px" }}
                        >
                          Security Measures
                        </h6>
                        <ul
                          className="list-group"
                          style={{ marginTop: "12px" }}
                        >
                          <li className="list-group-item">
                            Secure payment gateways should be in place to ensure
                            that your payment information remains private and
                            protected.
                          </li>
                        </ul>
                      </div>

                      <div className="mb-3">
                        <h6 className="font-weight-bold">
                          Charges & Additional Fees
                        </h6>
                        <ul className="list-group">
                          <li
                            className="list-group-item"
                            style={{ marginTop: "12px" }}
                          >
                            Some services may charge transaction fees or
                            processing fees for using specific payment methods,
                            like credit cards or third-party payment services.
                          </li>
                          <li className="list-group-item">
                            Always check the total amount due, including any
                            extra charges.
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div>
                      <h6 className="font-weight-bold">Refund Policies</h6>
                      <ul className="list-group">
                        <li
                          className="list-group-item"
                          style={{ marginTop: "12px" }}
                        >
                          Payments made through online are non-refundable.
                        </li>
                        <li className="list-group-item">
                          Once paid fees are neither refundable or adjustable
                          under any circumstances.
                        </li>
                        <li className="list-group-item">
                          We have a strict "no refund" policy for any kind of
                          payments.
                        </li>
                        <li className="list-group-item">
                          If there is a system error/duplicate payment/wrong
                          amount, the amount will be refunded by taking
                          permission from Rajya Vokkaligara Sangha (RVS).
                        </li>
                      </ul>
                    </div>

                    <div className="section-title with-desc text-left clearfix paddingtop-2">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h4 className="title">Terms & Conditions</h4>
                      </div>
                      <ul className="list-group">
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          These Terms and Conditions, along with the Privacy
                          Policy and other applicable terms ("Terms"),
                          constitute a binding agreement between RAJYA
                          VOKKALIGARA SANGHA ("Website Owner," "we," "us," or
                          "our") and you ("you" or "your"). These Terms govern
                          your use of our website, goods (if applicable), and
                          services (collectively, "Services").
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          By using our website and availing of our Services, you
                          confirm that you have read, understood, and accepted
                          these Terms (including the Privacy Policy). We reserve
                          the right to modify these Terms at any time without
                          prior notice. It is your responsibility to
                          periodically review them to stay informed of updates.
                        </li>

                        <div
                          style={{ marginTop: "1rem", marginBottom: "1rem" }}
                        >
                          <h5>Terms of Use</h5>
                        </div>

                        <li className="list-group-item">
                          The use of this website or availing of our Services is
                          subject to the following conditions:
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          To access and use the Services, you agree to provide
                          true, accurate, and complete information during
                          registration and afterward. You are responsible for
                          all activities carried out using your registered
                          account.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          Neither we nor third parties provide any warranty or
                          guarantee regarding the accuracy, timeliness,
                          performance, completeness, or suitability of the
                          information and materials available on this website or
                          through the Services for any specific purpose. You
                          acknowledge that such materials may contain
                          inaccuracies or errors, and we expressly exclude
                          liability for any such inaccuracies or errors to the
                          fullest extent permitted by law.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          You use our Services and website at your own risk and
                          discretion. You are responsible for independently
                          assessing and ensuring that the Services meet your
                          requirements.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          The contents of the website and the Services are
                          proprietary to us, and you do not have any
                          intellectual property rights, title, or interest in
                          them.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          Unauthorized use of the website or Services may lead
                          to legal action against you under these Terms and
                          applicable laws.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          You agree to pay any charges associated with availing
                          of the Services, as applicable. You agree not to use
                          the website or Services for any unlawful, illegal, or
                          prohibited purpose under these Terms, Indian law, or
                          any other applicable laws.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          You acknowledge that this website and the Services may
                          contain links to third-party websites. Upon accessing
                          such links, you will be governed by the terms of use,
                          privacy policy, and other policies of those
                          third-party websites. We are not responsible for any
                          content, services, or transactions on such websites.
                        </li>

                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          By initiating a transaction for availing of the
                          Services, you enter into a legally binding and
                          enforceable contract with us.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          If we are unable to provide the requested Service, you
                          may be entitled to a refund. Refund eligibility and
                          timelines will be determined based on the specific
                          Service policies. If you fail to request a refund
                          within the stipulated time, you may no longer be
                          eligible for one.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          Any disputes arising from or in connection with these
                          Terms shall be subject to the exclusive jurisdiction
                          of the courts in Bangalore South, Karnataka.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          Any concerns or communications regarding these Terms
                          must be directed to us using the contact information
                          provided on this website.
                        </li>
                      </ul>
                    </div>

                    <div className="section-title with-desc text-left clearfix paddingtop-2">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h4 className="title">Privacy Policy</h4>
                      </div>
                      <ul className="list-group">
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          Your privacy is of utmost importance to Bangalore
                          Institute of Technology (BIT). We are committed to
                          protecting your personal information and ensuring
                          transparency in how we collect, use, and safeguard
                          your data. BIT does not give, share, sell, or transfer
                          any personal information to third parties without your
                          explicit consent.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          <strong>Scope of this Privacy Policy:</strong> This
                          Privacy Policy applies to the information collected
                          when you visit the official website of Bangalore
                          Institute of Technology (
                          <a
                            href="http://www.bit-bangalore.edu.in"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            www.bit-bangalore.edu.in
                          </a>{" "}
                          and{" "}
                          <a
                            href="https://bitwebserver.bittechlearn.online:8084"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            https://bitwebserver.bittechlearn.online:8084
                          </a>
                          ) and its associated sub-sites owned, managed, and
                          controlled by the institute. This policy explains how
                          we collect, process, and protect visitor information.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          <strong>Browsing Behaviour:</strong> We track visitor
                          browsing patterns to analyse website usage and enhance
                          user experience. BIT deploys tools like Google
                          Analytics to collect anonymous statistics, which help
                          improve the website’s functionality. The following
                          details may be identified:
                          <ul>
                            <li>
                              Browser type and version (e.g., "Google Chrome
                              version Y" or "Mozilla Firefox version Y").
                            </li>
                            <li>
                              Operating system type (e.g., Windows, macOS,
                              UNIX).
                            </li>
                            <li>
                              Date and time of website visits, pages viewed, and
                              referral sources.
                            </li>
                            <li>
                              No personally identifiable information is recorded
                              in this process.
                            </li>
                          </ul>
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          <strong>Personal Information Collection:</strong> BIT
                          websites may request personally identifiable
                          information such as Name, Email ID, and Phone Number
                          for the following purposes:
                          <ul>
                            <li>
                              Event registrations (seminars, workshops, training
                              programs).
                            </li>
                            <li>
                              Online counselling, quizzes, or admission-related
                              inquiries.
                            </li>
                            <li>
                              Subscription to newsletters or other communication
                              materials.
                            </li>
                          </ul>
                          BIT does not sell, share, or disclose the information
                          provided on its websites to third parties, except when
                          legally required.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          <strong>Email Communication:</strong> If you contact
                          us via email, your email address and message contents
                          may be used to respond to your inquiries. Please be
                          aware that email communication is not always secure;
                          avoid sharing sensitive personal details over email.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          <strong>Interactive Forms:</strong> Some pages on our
                          website contain interactive forms where users can
                          voluntarily submit personal information for specific
                          purposes. This data is strictly used for the intended
                          purpose and is not shared with external entities.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          <strong>Use of Cookies:</strong> BIT websites use
                          cookies to enhance user experience. The types of
                          cookies we use include:
                          <ul>
                            <li>
                              <strong>Necessary Cookies:</strong> Enable smooth
                              website functionality.
                            </li>
                            <li>
                              <strong>Performance Cookies:</strong> Gather
                              anonymous browsing data to improve website
                              performance.
                            </li>
                            <li>
                              <strong>Functional Cookies:</strong> Remember user
                              preferences and previous interactions to provide a
                              personalized experience.
                            </li>
                          </ul>
                          Users can disable cookies via browser settings, but
                          this may impact certain website functionalities.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          <strong>Third-Party Links:</strong> BIT websites may
                          contain links to third-party websites. BIT is not
                          responsible for the privacy practices of these
                          external sites and encourages users to review their
                          privacy policies before providing personal
                          information.
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          <strong>Contact Us:</strong> For inquiries regarding
                          this Privacy Policy, please contact:
                          <br />
                          Web Administrator
                          <br />
                          Bangalore Institute of Technology
                          <br />
                          K.R. Road, V.V. Pura,
                          <br />
                          Bangalore - 560004, Karnataka, India
                          <br />
                          Email: webmaster@bit-bangalore.edu.in
                        </li>
                        <li
                          className="list-group-item"
                          style={{ textAlign: "justify" }}
                        >
                          This Privacy Policy is subject to periodic updates.
                          Continued use of BIT websites signifies your
                          acceptance of any modifications.
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div
                    className="title-header paddingtop-2"
                    style={{ borderTopColor: "red" }}
                  >
                    <h4 className="title">Contact information</h4>
                  </div>
                  <div className="ttm-pf-single-detail-box mb-35">
                    <ul className="ttm-pf-detailbox-list">
                      <li>
                        <i className="fa fa-user" />
                        <span>
                          {" "}
                          Principal - Bangalore Institute of Technology - K.R.
                          Road, V V Pura - Bangalore-560004
                        </span>
                      </li>
                      <li>
                        <i className="fas fa-envelope" />
                        <span>
                          {" "}
                          Mail-ID :{" "}
                        </span>admission@bit-bangalore.edu.in{" "}
                      </li>
                      <li>
                        <i className="fas fa-phone" />
                        <span> Contact Number : </span>+91-9448512984,
                        +91-9448512954
                      </li>
                    </ul>
                  </div>
                  <div className="ttm-pf-single-detail-box mb-35">
                    <h5>
                      For Admission queries please call during working hours
                    </h5>
                    <ul className="ttm-pf-detailbox-list">
                      <li>
                        <h6>
                          <span> Working Hours :</span>
                        </h6>
                      </li>
                      <li>
                        <i className="fas fa-caret-right" />
                        <span> Monday to Fiday </span>9.00 AM - 5.00 PM /{" "}
                        <span> Saturday</span>9.00 AM - 2.00 PM{" "}
                      </li>
                    </ul>
                  </div>
                  <div className="ttm-pf-single-detail-box mb-35">
                    <a
                      className="ttm-btn ttm-btn-size-md ttm-btn-style-border ttm-btn-color-white"
                      href={`${
                        process.env.PUBLIC_URL + "/assets/pdf/Admission/MCA.pdf"
                      }`}
                      target="_blank"
                    >
                      <h5>
                        Please download application form for MCA Program
                        Admission . . . . .{" "}
                      </h5>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <AdmissionSidebar />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
